export const SET_VENDORCODE = (state, value) => {
  state.vendor = value
}

export const SET_DESCRIPTION = (state, value) => {
  state.description = value
}

export const SET_PRICEBATCH = (state, value) => {
  if (value && !isNaN(value)) {
    value = parseFloat(value)
  }
  state.amount = value
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}
